<!-- Translated: skip -->
<template>

  <div :class="{'discount-offer': true, 'clickable': clickLink}" @click="goToLink" v-if="SITE_CONFIG.modules_open.skiletting.open && SITE_CONFIG.rental.currently_discounted">
    <div class="splash">Just nu <div class="larger">10% rabatt*</div></div>
    <div class="text">
      <h3>Kampanj på skidhyra</h3>
      <p>* 10% rabatt när du bokar komplett utrustningspaket för hela din boendeperiod.
        <span v-if="SITE_CONFIG.site === 'branas'">Söndag-torsdag, torsdag-söndag och söndag till söndag.</span>
      </p>
      <p class="smaller" v-if="SITE_CONFIG.site === 'branas'">(gäller t.o.m. 30/11 2023)</p>
      <p class="smaller" v-if="SITE_CONFIG.site === 'kungsberget'">(gäller t.o.m. 30/11 2023)</p>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    clickLink: '',
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    goTo(path) {
      this.$router.push({ path });
    },
    goToLink() {
      if (this.clickLink) {
        this.goTo(this.clickLink);
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.discount-offer
  max-width 95%
  width 600px
  position: relative
  display: flex
  justify-content: center;
  align-items: center;
  +max-xs-mobile()
    margin-top 10px
    margin-bottom: 0
  .text
    background-color #ffffff
    box-shadow 0 0 17px 0 rgba(0, 0, 0, 0.13)
    padding 15px 17px 15px 90px
    flex-grow 10
    +max-xs-mobile()
      box-shadow: none
      padding-left: 17px
      order -1
    p
      margin-bottom: 5px
    h3
      united-heavy()
      margin-bottom: 5px
      font-size: 20px
    .smaller
      font-size: 90%
  &.clickable:hover
    cursor: pointer;
    h3
      text-decoration: underline;
  .splash
    margin-right -70px
    background: brick;
    flex-shrink: 0
    width: 140px;
    height: 140px;
    border-radius: 50%;
    font-size: 20px
    padding: 42px 10px 10px 10px
    text-align: center;
    font-family  "UnitedSerifCond Heavy"
    font-weight: 900
    color: #fff
    transform: rotate(-9deg);
    border: 3px solid #fff
    line-height: 1.1em
    .larger
      font-size 115%
    +max-xs-mobile()
      margin-right: 0
      width: 100px;
      height: 100px;
      font-size: 15px
      padding-top 32px
    // +max-mobile()
    //   left: 20px
    // +max-xs-mobile()
    //   position: relative;
    //   margin: 0 auto
    //   right: 0px;
    //   transform: rotate(5deg);
    //   font-size: 15px
    //   width: 100px
    //   height: 100px
</style>



// WEBPACK FOOTER //
// SkiRentalDiscount.vue?7e53d1a7